module.exports = __webpack_public_path__ + "img/psycwave.76fbf87e.png";